import parse from "html-react-parser";
import { memo } from "react";
import { PATH_FAVORITES, PATH_SEARCH_RESULT } from "@routes";
import { ITourElement } from "@interfaces";
import { IconClock } from "@components";
import { sliceString, breakpoint } from "@utilities";
import useImageFallback from "src/Utilities/imageFallbackHelper";
import { Link } from "react-router-dom";
import styled from "styled-components";

interface IProps {
    data: ITourElement;
}

export const SearchTourElementModule = memo((props: IProps) => {
    const pathname = window.location.pathname;
    const {
        productImagePath,
        name,
        location,
        durationDays,
        durationNight,
        rrp,
        description,
        supplier,
        productSmallToMediumSizeImagePath,
        productLargeSizeImagePath,
    } = props.data;
    // const isLiked = favoritesTours.some((tour) => tour.productId === props.data.productId);
    const isFavoritePage = window.location.pathname === PATH_FAVORITES;

    let duringTime = "";
    if (Number(durationDays) > 0) {
        duringTime += `${durationDays} ${Number(durationDays) === 1 ? "day" : "days"}`;
    }
    if (Number(durationDays) > 0 && Number(durationNight) > 0) {
        duringTime += " , ";
    }
    if (Number(durationNight) > 0) {
        duringTime += `${durationNight} ${Number(durationNight) === 1 ? "night" : "nights"}`;
    }

    const imageSrc = useImageFallback({
        productImagePath,
        productSmallToMediumSizeImagePath,
        productLargeSizeImagePath,
    });

    return (
        <Container>
            <div
                className={`heart ${pathname === PATH_SEARCH_RESULT ? "searchResultPage" : ""}`}
                style={pathname.includes("favorites") ? { right: "15px" } : {}}
            ></div>
            <StyledTourElementSearch
                to={`/detail-tour/${props.data.productId}`}
                style={pathname.includes("favorites") ? { width: "unset", margin: 0 } : {}}
            >
                <div
                    className="tour_image"
                    style={{
                        backgroundImage: `url(${imageSrc})`,
                    }}
                ></div>
                <div className="main">
                    <div className="info">
                        <p className="destination__title">{name}</p>
                        <p className="destination__place">
                            <span className="placeName">{location}</span>
                        </p>
                        {!isFavoritePage && !!description && !(typeof description === "object") && (
                            <div className="description">
                                <span>{parse(description)}</span>
                            </div>
                        )}
                        {!!supplier && !(typeof description === "object") && (
                            <div className="supplier">
                                Supplier <span>{sliceString(supplier, 4)}</span>
                            </div>
                        )}
                    </div>
                    <div className="durationNPrice">
                        <div className="destination__price">
                            <span className="form">From</span>
                            <span className="price">${Number(rrp).toFixed(2)}</span>
                        </div>

                        <div className="destination__duration">
                            <IconClock />
                            <span className="time">{duringTime}</span>
                        </div>
                    </div>
                </div>
            </StyledTourElementSearch>
        </Container>
    );
});
const Container = styled.div`
    position: relative;
`;

const StyledTourElementSearch = styled(Link)`
    display: flex;
    position: relative;
    margin-bottom: 36px;

    ${breakpoint.breakTablet`
        height: 208px;
    `}

    ${breakpoint.breakIpadPro`
        height: 284px;
    `}

    .tour_image {
        position: relative;
        width: 100%;
        background-repeat: no-repeat;
        background-position: center;
        flex: 1;
        background-color: #fff;
        background-size: cover;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
    }

    .main {
        flex: 2;
        display: flex;
        flex-direction: column;
        padding-top: 0 !important;

        .info {
            flex: 1;
            background-color: #fff;
            padding: 16px;
            min-height: 110px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            border-top-right-radius: 8px;

            ${breakpoint.breakTablet`
                padding: 10px;
                min-height: 80px;
            `}

            ${breakpoint.breakIpadPro`
                padding: 24px;
                min-height: 110px;
            `}
            
            ${breakpoint.breakLarge`
                padding: 31px;
                min-height: 125px;
            `}

            p {
                margin: 0;
                font-weight: 700;
                font-size: 18px;
                line-height: 1.3em;
                color: ${(props) => props.theme.colors.black};
                max-width: 75%;
                ${breakpoint.breakTablet`
                    font-size: 12px;
                `}

                ${breakpoint.breakIpadPro`
                    font-size: 16px;
                `}
                
                ${breakpoint.breakLarge`
                    font-size: 20px;
                `}
            }

            .destination__place {
                margin-top: 12px;
                font-weight: 400;
                display: flex;
                align-items: center;

                ${breakpoint.breakTablet`
                    margin-top: 4px;
                    font-size: 12px;
                `}

                ${breakpoint.breakIpadPro`
                    margin-top: 6px;
                `}
                
                ${breakpoint.breakLarge`
                    margin-top: 12px;
                    font-size: 12px;
                `}
            
                svg {
                    margin-right: 5px;
                    width: 19px;

                    ${breakpoint.breakMobile`
                        margin-right: 10px;
                        width: 15px;
                    `}

                    ${breakpoint.breakTablet`
                        margin-right: 5px;
                    `}

                    ${breakpoint.breakIpadPro`
                        margin-right: 10px;
                        width: 19px;
                    `}
                }
                .placeName {
                    line-height: 1.3em;
                    font-size: 14px;
                    font-weight: 400;

                    ${breakpoint.breakMobile`
                        font-size: 16px;
                    `}

                    ${breakpoint.breakTablet`
                        font-size: 10px;
                    `}

                    ${breakpoint.breakIpadPro`
                        font-size: 12px;
                    `}
                    
                    ${breakpoint.breakLarge`
                        font-size: 16px;
                    `}
                }
            }

            .description {
                margin-top: 12px;
                font-weight: 400;
                font-size: 12px;
                height: 40px;
                overflow: hidden;
                line-height: 22px;
                color: ${({ theme }) => theme.colors.gray_2};

                ${breakpoint.breakTablet`
                    font-size: 10px;
                `}

                ${breakpoint.breakIpadPro`
                    font-size: 12px;
                `}


                ${breakpoint.breakLarge`
                    font-size: 14px;
                `}

                span {
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 2;
                }
            }

            .supplier {
                font-weight: 700;
                font-size: 12px;
                margin-top: 12px;
                line-height: 1.5em;

                ${breakpoint.breakTablet`
                    font-size: 10px;
                `}

                ${breakpoint.breakIpadPro`
                    font-size: 12px;
                `}


                ${breakpoint.breakLarge`
                    font-size: 14px;
                `}

                span {
                    color: ${(props) => props.theme.colors.main};
                }
            }
        }
        .durationNPrice {
            background-color: #000;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: #fff;
            padding: 0 16px;
            border-bottom-right-radius: 8px;

            ${breakpoint.breakTablet`
                padding: 0 10px;
            `}

            ${breakpoint.breakIpadPro`
                padding: 0 24px;
            `}
            
            ${breakpoint.breakLarge`
                padding: 0 31px;
            `}
        
        .destination__duration {
                display: flex;
                align-items: center;

                svg {
                    margin-right: 5px;
                    width: 19px;

                    ${breakpoint.breakMobile`
                    margin-right: 10px;
                    width: 15px;
                `}

                    ${breakpoint.breakTablet`
                    margin-right: 5px;
                `}

                ${breakpoint.breakIpadPro`
                    margin-right: 10px;
                    width: 19px;
                `}
                
                path {
                        stroke: #ffffff;
                    }
                }
                span {
                    font-size: 14px;
                    font-weight: 400;
                    white-space: nowrap;

                    ${breakpoint.breakMobile`
                    font-size: 16px;
                `}

                    ${breakpoint.breakTablet`
                    font-size: 10px;
                `}

                ${breakpoint.breakIpadPro`
                    font-size: 12px;
                `}
                
                ${breakpoint.breakLarge`
                    font-size: 16px;
                `}
                }
            }

            .destination__price {
                display: flex;
                align-items: center;

                span {
                    font-size: 12px;
                    font-weight: 400;

                    ${breakpoint.breakMobile`
                    font-size: 14px;
                `}

                    ${breakpoint.breakTablet`
                    font-size: 8px;
                `}

                ${breakpoint.breakIpadPro`
                    font-size: 12px;
                `}
                
                ${breakpoint.breakLarge`
                    font-size: 14px;
                `}
                }

                .price {
                    line-height: 26px;
                    font-size: 16px;
                    font-weight: 700;
                    margin-left: 9px;

                    ${breakpoint.breakMobile`
                    font-size: 20px;
                `}

                    ${breakpoint.breakTablet`
                    font-size: 12px;
                    margin-left: 4px;
                `}

                ${breakpoint.breakIpadPro`
                    font-size: 16px;
                    margin-left: 7px;
                `}
                
                ${breakpoint.breakLarge`
                    font-size: 20px;
                    margin-left: 9px;
                `}
                }
            }
        }
    }
`;
